var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-steps"},_vm._l((_vm.steps),function(step,idx){return _c('span',{class:['step', {active: (idx +1) == _vm.active }]},[_vm._v(_vm._s(idx + 1)+". "+_vm._s(step))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }